module.exports = __webpack_public_path__ + "img/article-doc-3-small.a09aa918.png";